module.exports = __webpack_public_path__ + "static/img/d-list.1bbac749.png";